import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69cfdbfd34b9ae001430a954_1780134571607/scalio/src/app/page.tsx");
